import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class GruposPagoService 
{
    constructor(private http: HttpClient) { }
    /*
    traeAgrupaciones(estado: any) 
    {
        return this.http.get(`${environment.urlApipagos}/agrupaciones/${estado}`, { headers: this.armaCabecera() } ).toPromise()
    }
    */
   

    traeAgrupaciones(estado: any,buscador:any){
        return this.http.post(`${environment.urlApipagos}/agrupaciones/buscador/`,
        {          
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            estado: estado
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }

    reenviarPagosPS(agrupacionId: any)  
    {
        return this.http.get(`${environment.urlApipagos}/revisarElementosEnCola/id/${agrupacionId}`, { headers: this.armaCabecera() } ).toPromise()
    }    
 

   traePdf(agrupacionId: any,tipoDocumento: string)  
    {
        return this.http.get(`${environment.urlApipagos}/documentos/id/${agrupacionId}/tipoDocumento/${tipoDocumento}`, { headers: this.armaCabecera() } ).toPromise()
    } 
    
    traeArchivos(idPostulacion: any)
    {   
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }
 
    traePostulacionesPorAgrupId(agrupacionId: any) 
    {
        return this.http.get(`${environment.urlApipagos}/postulaciones/agrupacion/${agrupacionId}`, { headers: this.armaCabecera() } ).toPromise()
    }
    
    firmaAgrupacion(idGrupo: any,idUsuarioAgrupa: any, codigo: string)
    {
     
       return  this.http.post(`${environment.urlApipagos}/primerafirma/`, 
       {
           id: idGrupo,
           idUsuarioAgrupa: idUsuarioAgrupa,
           otp:codigo
       }, 
       { headers: this.armaCabecera() } ).toPromise()
    }

    segundaFirmaAgrupacion(idGrupo: any,idUsuarioAgrupa: any, codigo: string)
    {
     
       return  this.http.post(`${environment.urlApipagos}/segundafirma/`, 
       {
           id: idGrupo,
           idUsuarioAgrupa: idUsuarioAgrupa,
           otp:codigo
       }, 
       { headers: this.armaCabecera() } ).toPromise()
    }



    eliminarAgrupacion(idGrupo: any)
    {
     
       return  this.http.delete(`${environment.urlApipagos}/agrupaciones/${idGrupo}`, 
       { headers: this.armaCabecera() } ).toPromise()
    }


    pagarAgrupacion(agrupacionId: any)
    {
     
       return  this.http.post(`${environment.urlApipagos}/agrupaciones/pagarAgrupacion`, 
       {
           id: agrupacionId
       }, 
       { headers: this.armaCabecera() } ).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}